// 回款申请dlg组件

const onReturnApplyDlg = {
  namespaced: true,

  state: {
    dlgShow: false,
  },

  getters: {
    dlgShow: state => state.dlgShow,
  },

  mutations: {
    SET_DLGSHOW: (state, val) => {
      state.dlgShow = val
    },
  },

  actions: {

  }
}

export default onReturnApplyDlg
